module.exports = __webpack_public_path__ + "static/media/golf.d824bd4a.jpg";